module.exports = __webpack_public_path__ + "img/icon1.bc6b0b52.svg";